import {createReducer} from '@reduxjs/toolkit';
import {setActiveCollection} from '@src/actions/feature-collections';

const initialState = {
  collectionId: null,
  collectionName: '',
  collectionTitleProperty: '',
};

const featureCollections = createReducer(initialState, builder => {
  builder.addCase(setActiveCollection, (state, {payload: collection}) => {
    state.collectionId = collection?.id ?? null;
    state.collectionName = collection?.title ?? '';
    state.collectionTitleProperty = collection?.title_property ?? '';
  });
});

export default featureCollections;
